// Helper function to check if the email belongs to Alvarez & Marsal domain. This is used in useUserMFAQuery(args: UserMFAQueryArgs) in apiQueries.ts
export function IsAlvarezAndMarsalDomain(email: string | undefined): boolean {
    const alvarezAndMarsalDomain = "alvarezandmarsal.com";

    if (email) {
        const formattedEmail = email.trim().toLowerCase();
        if (formattedEmail.endsWith(`@${alvarezAndMarsalDomain}`)) {
            return true;
        }
    }
    return false;
}
